<template>
  <div style="padding:20px;">
    <el-row style="margin-bottom:15px;">
      <el-button type="primary" @click="getData" icon="refresh">刷新</el-button>
    </el-row>
    <el-table :data="roles" tooltip-effect="dark" border stripe height="calc(100vh - 190px)" v-loading="loading"
      row-key="id" default-expand-all :tree-props="{'children': 'roleUsers'}">
      <el-table-column label="序号" width="55" type="index"></el-table-column>
      <el-table-column prop="name" label="名称" :min-width="200" show-overflow-tooltip>
        <template #="{row}">
            <el-tag size="small" v-if="row.userId" type="danger">人员</el-tag>
            <el-tag size="small" v-else>角色</el-tag>
          <span style="margin-left: 5px;">{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed">
      </el-table-column>
      <el-table-column label="启用">
        <template #default="{row}">
          <el-switch v-if="row.isEffective !== undefined" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" v-model="row.isEffective"
            inline-prompt disabled></el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getOrgRoleListByOrgId } from '@/api/sys/org';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    id: String,
    currColumnValue: Number
  },
  data() {
    return {
      loading: false,
      roles: [],
      tableColumns: [
        { prop: 'orgName', label: '公司', minWidth: 150 },
        { prop: 'sex', label: '性别', minWidth: 150 },
        { prop: 'phone', label: '手机号', minWidth: 150 }
      ]
    }
  },
  methods: {
    getData() {
      this.loading = true;
      getOrgRoleListByOrgId(this.id).then(({data}) => {
        this.roles = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    }
  },
  watch: {
    currColumnValue(val) {
      if (val === 3) {
        this.getData();
      }
    }
  }
})
</script>